import { c as _c } from "react/compiler-runtime";
import { SearchInputV2Props } from '@/comps/search-input';
import { cn } from '@/utils/shad';
import { Input } from '@/comps/primitives/input';
import { translateSafe } from '@/utils/translations';
import React, { useRef, useEffect, useState } from 'react';
interface FilterSearchInputProps extends SearchInputV2Props {
  autoFocus?: boolean;
}
export function FilterSearchInput(t0) {
  const $ = _c(22);
  const {
    search,
    setSearch,
    placeholder,
    className,
    autoFocus
  } = t0;
  const inputRef = useRef(null);
  const [shouldMaintainFocus, setShouldMaintainFocus] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShouldMaintainFocus(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleFocus = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShouldMaintainFocus(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleBlur = t2;
  let t3;
  let t4;
  if ($[2] !== autoFocus) {
    t3 = () => {
      if (autoFocus && inputRef.current) {
        inputRef.current.focus();
      }
    };
    t4 = [autoFocus];
    $[2] = autoFocus;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== search || $[6] !== shouldMaintainFocus) {
    t5 = () => {
      if (shouldMaintainFocus && inputRef.current && document.activeElement !== inputRef.current && search) {
        inputRef.current.focus();
        const length = inputRef.current.value.length;
        inputRef.current.setSelectionRange(length, length);
      }
    };
    t6 = [search, shouldMaintainFocus];
    $[5] = search;
    $[6] = shouldMaintainFocus;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== className) {
    t7 = cn("flex items-center justify-center", className);
    $[9] = className;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== placeholder) {
    t8 = placeholder ?? translateSafe("common", "searchEllipsis");
    $[11] = placeholder;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== setSearch) {
    t9 = e => setSearch(e.currentTarget.value);
    $[13] = setSearch;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== search || $[16] !== t8 || $[17] !== t9) {
    t10 = <Input ref={inputRef} placeholder={t8} className="w-full rounded border border-b bg-background px-3 text-[12px] focus-visible:ring-0" value={search} onChange={t9} onFocus={handleFocus} onBlur={handleBlur} type="search" />;
    $[15] = search;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7) {
    t11 = <div className={t7}>{t10}</div>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}